import React from 'react'

export const ForgotPasswordConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    routes: [
        {
            path: '/forgotPassword',
            component: React.lazy(() => import('./ForgotPassword')),
            applicationPath: 'ForgotPassword'
        },
        {
            path: '/resetPassword',
            component: React.lazy(() => import('./ResetPassword')),
            applicationPath: 'ResetPassword'
        }
    ]
}

